import GameSettings from "./Settings";
import "./settings.scss";

export default GameSettings;
